export default {
  getLabelToggleState: state => (state.isShowingLabels ? 'on' : 'off'),
};
